<template>
  <v-container fluid style="background-color: var(--v-background-base);" class="pa-10">
   <v-form ref="dashboardForm">
     <v-card class="card-quote" elevation="0">
       <v-card-text>
         <v-row class="px-5">
           <v-col cols="12" style="color: var(--v-darkblue-base); font-weight: bold; font-size: 16px;">
             <!-- <v-img src="img/icons/dashboard_title_quotes.png" width="120" contain></v-img> -->
             <div
              class="d-flex flex-row align-center">
              <v-sheet
                color="title-icon"
                class="d-flex justify-center align-center rounded-circle"
                height="38"
                width="38">
                <v-icon color="title-icon-background" size="20">fas fa-copy</v-icon>
              </v-sheet>
              <span
                class="title-foreground--text font-weight-medium ml-2">
                Cotações
              </span>
            </div>
           </v-col>

           <v-col cols="12" md="3" class="component-col pr-md-0 mr-md-0 py-0 my-0">
             <v-text-field
               label="CNPJ"
               maxlength="18"
               v-mask="[$util.formmasks.cnpj]"
               :rules="[$util.formrules.cnpjNotRequired]"
               v-model="quoteFilters.cpfCnpj"
               validate-on-blur
               outlined
               clearable
               dense
             />
           </v-col>
           <v-col cols="12" md="5" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0">
             <v-text-field
               label="Nome / Razão Social"
               maxlength="255"
               v-model="quoteFilters.comercialName"
               validate-on-blur
               outlined
               clearable
               dense
             />
           </v-col>
           <v-col cols="12" md="2" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0">
             <v-text-field
               label="Número da Cotação"
               maxlength="10"
               v-model="quoteFilters.quoteNumber"
               @keydown="$util.acceptOnlyNumbers"
               validate-on-blur
               outlined
               clearable
               dense
             />
           </v-col>
           <v-col cols="12" md="2" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0">
             <v-text-field
               label="Número do Kit"
               maxlength="10"
               v-model="quoteFilters.kitNumber"
               @keydown="$util.acceptOnlyNumbers"
               validate-on-blur
               outlined
               clearable
               dense
             />
           </v-col>
           <v-col cols="12" md="3" sm="6" class="component-col pr-md-0 mr-md-0 py-0 my-0">
             <v-text-field
               label="Usuário de Criação"
               maxlength="255"
               v-model="quoteFilters.createUser"
               validate-on-blur
               outlined
               clearable
               dense
             />
           </v-col>
           <v-col cols="12" md="3" sm="6" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0">
             <v-text-field
               label="Corretor / Parceiro"
               v-model="quoteFilters.broker"
               maxlength="255"
               validate-on-blur
               outlined
               clearable
               dense
             />
           </v-col>
           <v-col cols="12" md="2" sm="3" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0">
             <v-menu
               ref="menuStartDate"
               v-model="menuStartDate"
               :close-on-content-click="false"
               :return-value.sync="quoteFilters.startDate"
               transition="scale-transition"
               offset-y
               min-width="auto"
             >
               <template v-slot:activator="{ on, attrs }">
                 <v-text-field
                   :value="formatStartDate"
                   label="Data Início"
                   append-icon="mdi-calendar"
                   readonly
                   v-bind="attrs"
                   v-on="on"
                   outlined
                   dense
                 ></v-text-field>
               </template>
               <v-date-picker
                 v-model="quoteFilters.startDate"
                 no-title
                 scrollable
                 @change="() => {$refs.menuStartDate.save(quoteFilters.startDate); verifyStartDateGreaterThanEndDate(); }"
               />
             </v-menu>
           </v-col>
           <v-col cols="12" md="2" sm="3" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0">
             <v-menu
               ref="menuEndDate"
               v-model="menuEndDate"
               :close-on-content-click="false"
               :return-value.sync="quoteFilters.endDate"
               transition="scale-transition"
               offset-y
               min-width="auto"
             >
               <template v-slot:activator="{ on, attrs }">
                 <v-text-field
                   :value="formatEndDate"
                   label="Data Fim"
                   append-icon="mdi-calendar"
                   readonly
                   v-bind="attrs"
                   v-on="on"
                   outlined
                   dense
                 ></v-text-field>
               </template>
               <v-date-picker
                 v-model="quoteFilters.endDate"
                 no-title
                 scrollable
                 @change="() => {$refs.menuEndDate.save(quoteFilters.endDate); verifyStartDateGreaterThanEndDate();}"
               />
             </v-menu>
           </v-col>
           <v-col cols="12" md="2" sm="6" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0 d-flex align-center">
             <v-radio-group v-model="quoteFilters.type" row style="min-height: 45px; padding: 0 !important; margin: 0px !important;">
               <v-radio class="mr-2" label="Cotação" value="C"></v-radio>
               <v-radio class="mr-2" label="Kit" value="K"></v-radio>
               <v-radio class="mr-2" label="Ambos" value="A"></v-radio>
             </v-radio-group>
           </v-col>
         </v-row>
         
         <v-row class="px-5" justify-sm="end">
           <v-col cols="auto" class="d-none d-sm-flex">
             <v-btn
               @click="search()"
               class="btn-quote"
               large>
               <v-icon left>fas fa-search</v-icon>
               Buscar
             </v-btn>
             
           </v-col>
           <v-col cols="12" class="d-flex d-sm-none d-md-none d-lg-none d-xl-none">
             <v-btn
               class="btn-quote"
               block
               large>
               <v-icon left>fas fa-search</v-icon>
               Buscar
             </v-btn>
           </v-col>
         </v-row>
         
         <v-row class="px-5">
           <v-col cols="12" style="color: var(--v-darkblue-base); font-weight: bold; font-size: 16px;">
            <!-- <v-img src="img/icons/dashboard_title_search_result.png" width="203" contain></v-img> -->
            <div
              class="d-flex flex-row align-center">
              <v-sheet
                color="title-icon"
                class="d-flex justify-center align-center rounded-circle"
                height="38"
                width="38">
                <v-icon color="title-icon-background" size="20">fas fa-list</v-icon>
              </v-sheet>
              <span
                class="title-foreground--text font-weight-medium ml-2">
                Resultado da Busca
              </span>
            </div>
           </v-col>
           <v-col cols="12">
             <v-data-table
               class="elevation-1 quote-table"
               item-key="quoteId"
               :headers="headers"
               :items="items"
               :loading="loading"
               loading-text="Carregando..."
               :items-per-page="-1"
               hide-default-footer
             >
               <template v-slot:item.createdDate="{ item }">
                 {{ item.createdDate ? $util.formatDateFromBR(item.createdDate) : '-' }}
               </template>

               <template v-slot:item.cnpj="{ item }">
                 {{ item.cnpj ? $util.formatCNPJ(item.cnpj) : '-' }}
               </template>

               <template v-slot:item.comercialName="{ item }">
                <div :class="item.comercialName ? '' : 'd-flex justify-center'">{{ item.comercialName ? item.comercialName : '-' }}</div>
               </template>
            
               <template v-slot:item.createdUserName="{ item }">
                <div :class="item.createdUserName ? '' : 'd-flex justify-center'">{{ item.createdUserName ? item.createdUserName : '-' }}</div>
               </template>

               <template v-slot:item.broker="{ item }">
                <div :class="item.broker ? '' : 'd-flex justify-center'">{{ item.broker ? item.broker : '-' }}</div>
               </template>

               <template v-slot:item.quoteType="{ item }">
                 {{ item.quoteType ? item.quoteType.toUpperCase().replace('PLAN_CATEGORY', 'PJ - Categoria de Plano') : '-' }}
               </template>
               
               <template v-slot:item.actions="{ item }">
                 <v-menu left open-on-click offset-y>
                   <template v-slot:activator="{ on, attrs }">
                     <v-btn icon v-bind="attrs" v-on="on">
                       <v-icon>fas fa-cog</v-icon>
                     </v-btn>
                   </template>

                   <v-list v-if="actionItems && actionItems.length">
                     <v-list-item dense v-for="(actionItem, index) in actionItems" :key="index" @click="onClickMenuAction(item, actionItem.code)">
                       <v-list-item-title>
                         <!-- <v-img
                           :src="actionItem.img"
                           :height="actionItem.height ? actionItem.height: '20'"
                           :width="actionItem.width ? actionItem.width: ''"
                           position="left"
                           contain>
                         </v-img> -->
                         <div
                          class="d-flex flex-row align-center">
                          <v-sheet
                            icon
                            color="title-icon"
                            class="d-flex justify-center align-center rounded-circle"
                            height="38"
                            width="38">
                            <v-icon color="title-icon-background" size="20">{{actionItem.icon}}</v-icon>
                          </v-sheet>
                          <span
                            :class="{
                              'font-weight-medium ml-2 foreground--text':true,
                              'title-foreground--text': !$vuetify.theme.dark,
                              'foreground--text': $vuetify.theme.dark,
                            }">
                            {{actionItem.description}}
                          </span>
                        </div>
                       </v-list-item-title>
                     </v-list-item>
                   </v-list>
                 </v-menu>
               </template>
             </v-data-table>
           </v-col>
         </v-row>
       </v-card-text>
     </v-card>
   </v-form>
  </v-container>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import moment from "moment";
import {saveAs} from "file-saver";
import {extension} from "mime-types";
import QuoteService from "@/services/odoo/QuoteService";
import XippAuthService from "@/services/auth/XippAuthService";

export default {
  name: 'dashboardQuote',
  data: () => ({
    sessionStorageKey: 'quoteDataObj',
    loading: false,
    dateFormatExp: 'DD/MM/YYYY',
    menuStartDate: false,
    menuEndDate: false,
    quoteFilters: {
      cpfCnpj: null,
      comercialName: null,
      quoteNumber: null,
      kitNumber: null,
      createUser: null,
      broker: null,
      type: null,
      startDate: null,
      endDate: null,
    },
    headers: [
      { text: "N° da Cotação", width: '10%', value: "quoteNumber", class: 'muted white--text', align: 'center' },
      { text: "Data da Criação", value: "createdDate", width: '12%', class: 'muted white--text', align: 'center' },
      { text: "CNPJ", value: "cnpj", width: '15%', class: 'muted white--text', align: 'center'  },
      { text: "Nome / Razão Social", value: "comercialName",  class: 'muted white--text' },
      { text: "Usuário de Criação", width: '12%', value: "createdUserName",  class: 'muted white--text' },
      { text: "Corretor / Parceiro", width: '12%', value: "broker",  class: 'muted white--text' },
      { text: "Benefício", value: "benefit",  class: 'muted white--text' },
      { text: "Tipo", value: "quoteType",  class: 'muted white--text' },
      { text: "Ações", value: "actions", sortable: false, align: "right", class: 'muted white--text' }
    ],
    items: [],
    actionItems: [
      { code: 'prospect', img: 'img/icons/dashboard_opportunity.png', icon: 'far fa-file-alt', description: 'Oportunidade', height: '25' },
      { code: 'edit', img: 'img/icons/dashboard_edit.png', icon: 'fas fa-edit', description: 'Editar', width: '76', height: '25' },
      { code: 'detail', img: 'img/icons/dashboard_detail.png', icon: 'fas fa-clipboard-list', description: 'Detalhar', width: '97', height: '25' },
      { code: 'download_quote', img: 'img/icons/dashboard_download_quote.png', icon: 'fas fa-file-pdf', description: 'Download da última cotação', width: '242', height: '25' },
      { code: 'download_resume', img: 'img/icons/dashboard_download_resume.png', icon: 'fas fa-file-invoice-dollar', description: 'Download Resumo Financeiro', width: '244', height: '28' },
      { code: 'resend_kit', img: 'img/icons/dashboard_resend_kit.png', icon: 'fas fa-folder', description: 'Reenviar Kit', width: '119', height: '20' },
      { code: 'new_kit', img: 'img/icons/dashboard_new_kit.png', icon: 'fas fa-folder-plus', description: 'Novo Kit', width: '93', height: '22' },
    ],
  }),

  methods: {
    ...mapMutations(['showmsg', 'setDialogLoading']),
    ...mapActions(['setParentQuoteId', 'setBenefitsObj']),
    verifyStartDateGreaterThanEndDate() {
      if(this.quoteFilters.startDate && this.quoteFilters.endDate) {
        if(moment(this.quoteFilters.startDate, 'YYYY-MM-DD').diff(moment(this.quoteFilters.endDate, 'YYYY-MM-DD')) > 0) {
          this.showmsg({text: 'A Data Fim não pode ser menor que a Data Início.', type: 'warning'});
          setTimeout(() => {
            this.quoteFilters.endDate = null;
          }, 100);
        }
      }
    },
    onClickMenuAction(item, code) {
      switch (code) {
        case 'prospect':
          this.onClickProspect(item);
          break;
        case 'edit':
          this.onClickEditOrDetail(item, 'edit');
          break;
        case 'detail':
          this.onClickEditOrDetail(item, 'detail');
          break;
        case 'new_kit':
          this.onClickEditOrDetail(item, 'new_kit');
          break;
        case 'download_quote':
        case 'download_resume':
          this.download(item.quoteId, code);
          break;
        case 'resend_kit':
          this.onClickSendKit(item);
          break;
        default:
      }
    },
    onClickProspect(item) {
      if(item && item.prospectUrl) {
        window.open(item.prospectUrl, '_blank', 'noreferrer');
      } else {
        this.showmsg({text: 'O link de acesso não pode ser gerado no momento.', type: 'warning'});
      }
    },
    async onClickEditOrDetail(item, action) {
      this.setDialogLoading(true);
      
      if(item && item.quoteId) {
        localStorage.removeItem(this.sessionStorageKey);
        let quoteData = null;
        
        if(action === 'detail' || action === 'new_kit' || action === 'edit') {
          await this._quoteService.detail(item.quoteId)
            .then((response) => {
              if(response && response.data) {
                quoteData = response.data;
              }
            })
            .catch((error) => {
              this.setDialogLoading(false);
              if(error && error.response && error.response.status === 400) {
                this.showmsg({text: error.response.data.message, type: 'error'})
              } else {
                this.showmsg({text: 'Ocorreu um erro ao tentar detalhar a cotação.', type: 'error'})
              }
            });
        }
        
        if(quoteData) {
          const parentQuoteId = quoteData && quoteData.id ? quoteData.id : item.quoteId;
          
          const juridicalPersonObj = {
            cnpj: quoteData && quoteData.lead ? quoteData.lead.cnpj : null,
            legalName: quoteData && quoteData.lead ? quoteData.lead.commercialName : null,
            nameContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.name : null,
            phoneContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.mobilePhone : null,
            emailContact: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.email : null,
            emailWithCopy: quoteData && quoteData.lead && quoteData.lead.contact ? quoteData.lead.contact.emailCC : null,
            city : quoteData && quoteData.lead &&  quoteData.lead.city ? {
              id:  quoteData.lead.city.id,
              name: quoteData.lead.city.name,
              state_id: {
                id: quoteData.lead.city.state ? quoteData.lead.city.state.id : null,
                name: quoteData.lead.city.state ? quoteData.lead.city.state.name : null,
                code: quoteData && quoteData.lead && quoteData.lead.city && quoteData.lead.city.state ? quoteData.lead.city.state.code : null,
              }
            } : null,
          }
          
          const juridicalPersonKitObj = {
            cnpj: quoteData && quoteData.lead ? quoteData.lead.cnpj : null,
            legalName: quoteData && quoteData.lead ? quoteData.lead.commercialName : null,
            address: quoteData && quoteData.lead ? quoteData.lead.street : null,
            addressZip: quoteData && quoteData.lead ? quoteData.lead.zip : null,
            addressNeighborhood: quoteData && quoteData.lead ? quoteData.lead.district : null,
            addressNumber: quoteData && quoteData.lead ? quoteData.lead.streetNumber : null,
            addressComplement: quoteData && quoteData.lead ? quoteData.lead.complement : null,
            addressCity: quoteData && quoteData.lead && quoteData.lead.city ? quoteData.lead.city.name : null,
            addressState: quoteData && quoteData.lead && quoteData.lead.city && quoteData.lead.city.state ? quoteData.lead.city.state.code : null,
          };

          const planFiltersObj = {
            accommodations: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.accommodation && quoteData.contractFeatures.accommodation.length
              ? quoteData.contractFeatures.accommodation.map(item => item.code) : [],
            allEmployees: quoteData && quoteData.contractFeatures ? [quoteData.contractFeatures.allEmployees] : [],
            geographicScopes: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.geographicScope && quoteData.contractFeatures.geographicScope.length
              ? quoteData.contractFeatures.geographicScope.map(item => item.name) : [],
            hasCopay: quoteData && quoteData.contractFeatures ? [quoteData.contractFeatures.withCopay] : [],
            planClassifications: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.classification && quoteData.contractFeatures.classification.length
              ? quoteData.contractFeatures.classification.map(item => item.id ? item.id.toString() : null) : [],
            hospitalsObj: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.hospitalProviders && quoteData.contractFeatures.hospitalProviders.length
              ? quoteData.contractFeatures.hospitalProviders.map(item => item.id) : [],
            laboratoriesObj: quoteData && quoteData.contractFeatures && quoteData.contractFeatures.laboratoryProviders && quoteData.contractFeatures.laboratoryProviders.length
              ? quoteData.contractFeatures.laboratoryProviders.map(item => item.id) : [],
          }


          let benefitsObj = quoteData && quoteData.benefit ? quoteData.benefit : [];
          if(benefitsObj && benefitsObj.length) {
            benefitsObj.forEach(benefit => {
              benefit.carriers.forEach(carrier => {
                const selectedPlans = carrier.selectedPlans;
                carrier.planClassifications.forEach(planClassification => {
                  planClassification.plans.forEach(plan => {
                    if(selectedPlans && selectedPlans.length && selectedPlans.some(selectedPlan => parseInt(selectedPlan.id) === parseInt(plan.id))) {
                      plan.selected = true;
                    }
                  });
                });
              });
            });
          }

          let ageIntervalsObj = [];
          let enumeratedAgesObj = [];
          let plansGroupByBenefitCarrierObj = [];
          if(quoteData && quoteData.type && quoteData.type === 'PJ'){
            ageIntervalsObj = quoteData && quoteData.ageRange ? quoteData.ageRange : [];
            enumeratedAgesObj = ageIntervalsObj[ageIntervalsObj.length - 1].beneficiariesFiftyNinePlus ?
              ageIntervalsObj[ageIntervalsObj.length - 1].beneficiariesFiftyNinePlus : [];
          } else if(quoteData && quoteData.type && quoteData.type === 'PJ_PLAN') {
            ageIntervalsObj = quoteData && quoteData.ageRange ? quoteData.ageRange : [];
            plansGroupByBenefitCarrierObj = this.groupPlansByBenefitCarrier(benefitsObj);
          }

          if(ageIntervalsObj && ageIntervalsObj.length) {
            ageIntervalsObj.forEach(item => {
              delete item.beneficiariesFiftyNinePlus;
            })
          }

          const projectObj = { id: null };
          if(quoteData && quoteData.studyConfigurationId) {
            projectObj.id = parseInt(quoteData.studyConfigurationId);
          }

          const quoteDataSession = {
            parentQuoteId,
            juridicalPersonObj,
            juridicalPersonKitObj,
            planFiltersObj,
            ageIntervalsObj,
            enumeratedAgesObj,
            benefitsObj,
            plansGroupByBenefitCarrierObj,
            projectObj
          }

          localStorage.setItem(this.sessionStorageKey, btoa(JSON.stringify(quoteDataSession)));

          const queryParams = {
            type: quoteData.type,
          }

          if(action === 'detail') {
            queryParams.detail = true;
          }

          if(action === 'new_kit') {
            await this.loadDataToRequestKit(quoteDataSession, queryParams.type);
          } else {
            this.$router.push({name: 'quote-form', query: queryParams });
          }
        }
      } else {
        let actionName = 'gerenciar';
        
        switch (action) {
          case 'edit':
            actionName = 'editar';
            break;
          case 'detail':
            actionName = 'detalhar';
            break;
          default:
        }
        this.showmsg({text: 'Não foi possível ' +actionName+ ' a cotação.', type: 'warning'});
      }
      this.setDialogLoading(false);
    },
    groupPlansByBenefitCarrier(benefits) {
      let plansGroupByBenefitCarrier = [];
      const sumTotals = {
        ageIntervalsSum: [
          { description: '0 a 18', sum: null },
          { description: '19 a 23', sum: null },
          { description: '24 a 28', sum: null },
          { description: '29 a 33', sum: null },
          { description: '34 a 38', sum: null },
          { description: '39 a 43', sum: null },
          { description: '44 a 48', sum: null },
          { description: '49 a 53', sum: null },
          { description: '54 a 58', sum: null },
          { description: '59 ou +', sum: null },
        ],
        total: null,
      };

      const initialAgeIntervals = [
        { description: '0 a 18', holderCount: null, dependentCount: null, total: null },
        { description: '19 a 23', holderCount: null, dependentCount: null, total: null },
        { description: '24 a 28', holderCount: null, dependentCount: null, total: null },
        { description: '29 a 33', holderCount: null, dependentCount: null, total: null },
        { description: '34 a 38', holderCount: null, dependentCount: null, total: null },
        { description: '39 a 43', holderCount: null, dependentCount: null, total: null },
        { description: '44 a 48', holderCount: null, dependentCount: null, total: null },
        { description: '49 a 53', holderCount: null, dependentCount: null, total: null },
        { description: '54 a 58', holderCount: null, dependentCount: null, total: null },
        { description: '59 ou +', holderCount: null, dependentCount: null, total: null },
      ];
      
      if(benefits && benefits.length) {
        benefits.forEach(benefitItem => {
          benefitItem.carriers.forEach(carrierItem => {
            carrierItem.planClassifications.forEach(planClassification => {
              planClassification.plans.forEach(planItem => {
                const planSelectedFound = carrierItem.selectedPlans.find(selectedPlan => parseInt(selectedPlan.id) === parseInt(planItem.id));
                
                if(planSelectedFound) {
                  const benefitCarrier = {
                    benefitId: benefitItem.id,
                    benefitName: benefitItem.name,
                    benefitCode: benefitItem.code,
                    carrierId: carrierItem.id,
                    carrierName: carrierItem.name,
                    carrierDirectoryKit: carrierItem.directoryKit,
                    carrierComercialName: carrierItem.comercialName,
                    carrierImage: carrierItem.image,
                    carrierIsReference: carrierItem.isReference,
                    plans: [],
                    sumTotals: JSON.parse(JSON.stringify(sumTotals)),
                  }

                  const plan = {
                    id: planItem.id,
                    name: planItem.name,
                    ageIntervals: planSelectedFound ? planSelectedFound.ageRange : initialAgeIntervals,
                    ageIntervalsTotal: {
                      sumHolderCount: null,
                      sumDependentCount: null,
                      sumTotal: null,
                    },
                  };

                  const benefitCarrierFound = plansGroupByBenefitCarrier.find(benefitCarrier =>
                    benefitCarrier.benefitId === benefitItem.id && benefitCarrier.carrierId === carrierItem.id);
                  if(benefitCarrierFound) {
                    const indexOfBenefitCarrier = plansGroupByBenefitCarrier.indexOf(benefitCarrierFound);
                    const planFound = benefitCarrierFound.plans.find(plan => plan.id === planItem.id);

                    if(planFound) {
                      const indexOfPlan = benefitCarrierFound.plans.indexOf(planFound);
                      plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.splice(indexOfPlan, 1);

                      if(!plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.length) {
                        plansGroupByBenefitCarrier.splice(indexOfBenefitCarrier, 1);
                      }

                    } else {
                      plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.push(plan);
                    }
                  } else {
                    benefitCarrier.plans.push(plan);
                    plansGroupByBenefitCarrier.push(benefitCarrier);
                  }
                }
              });
            });
          });
        });
      }
      return plansGroupByBenefitCarrier;
    },
    async search() {
      if(!this.$refs.dashboardForm.validate()) {
        return;
      }
      
      if(Object.values(this.quoteFilters).every(value => !value)) {
        this.showmsg({text: 'Preencha pelo menos um campo para efetuar a busca.', type: 'warning'});
        return;
      }
      
      this.loading = true;
      this.setDialogLoading(this.loading);
      const params = new URLSearchParams();

      if(this.quoteFilters && this.quoteFilters.broker) {
        params.append('broker', this.quoteFilters.broker);
      }
      
      if(this.quoteFilters && this.quoteFilters.cpfCnpj) {
        params.append('cnpj', this.quoteFilters.cpfCnpj);
      }

      if(this.quoteFilters && this.quoteFilters.comercialName) {
        params.append('comercialName', this.quoteFilters.comercialName);
      }

      if(this.quoteFilters && this.quoteFilters.createUser) {
        params.append('createUserName', this.quoteFilters.createUser);
      }

      if(this.quoteFilters && this.quoteFilters.startDate) {
        params.append('initialDate', this.quoteFilters.startDate);
      }

      if(this.quoteFilters && this.quoteFilters.endDate) {
        params.append('finalDate', this.quoteFilters.endDate);
      }

      if(this.quoteFilters && this.quoteFilters.kitNumber) {
        params.append('kitNumber', this.quoteFilters.kitNumber);
      }

      if(this.quoteFilters && this.quoteFilters.quoteNumber) {
        params.append('quoteNumber', this.quoteFilters.quoteNumber);
      }

      if(this.quoteFilters && this.quoteFilters.type) {
        params.append('typeSearch', this.quoteFilters.type);
      }
      
      this.items = [];
      await this._quoteService.findAllByFilter(params)
        .then((response) => {
          if(response && response.data && response.data.length) {
            this.items = response.data;
          }
        })
        .catch(() => {
          this.showmsg({text: 'Ocorreu um erro ao tentar efetuar a busca.', type: 'error'});
        });
      
      this.loading = false;
      this.setDialogLoading(this.loading);
    },
    async download(quoteId, fileType) {
      this.setDialogLoading(true);
      
      let quoteFileTypeEnum = null;
      switch (fileType) {
        case 'download_quote':
          quoteFileTypeEnum = 'QUOTE_FILE_PDF';
          break;
        case 'download_resume':
          quoteFileTypeEnum = 'FINANCIAL_RESUME_FILE_PDF';
          break;
        default:
      }
      
      if(quoteId && quoteFileTypeEnum) {
        await this._quoteService.download(quoteId, quoteFileTypeEnum)
          .then((response) => {
            const contentVersion = response && response.data ? response.data : null;
            if(contentVersion) {
              let fileName = contentVersion.name;
              let fileExtension = contentVersion.mimetype ? extension(contentVersion.mimetype) : null;
              
              if(fileExtension) {
                fileName = fileName + '.' + fileExtension;
              }
              
              if(contentVersion.datas) {
                const blobParts = this.$util.base64ToBytesArray(contentVersion.datas);
                saveAs(new Blob(blobParts, { type: contentVersion.mimetype }), fileName);
                
              } else {
                this.showmsg({text: 'Não foi possível gerar o conteúdo do arquivo. (Conteúdo vazio)', type: 'error'})
              }
            }
          })
          .catch((error ) => {
            if(error && error.response && error.response.status === 400) {
              this.showmsg({text: error.response.data.message, type: 'error'})
            } else {
              this.showmsg({text: 'Ocorreu um erro ao tentar efetuar o download do arquivo.', type: 'error'})
            }
          })
          .finally(() => {
            this.setDialogLoading(false);
          });
      }
    },
    async onClickSendKit(item) {
      this.setDialogLoading(true);

      if(item && item.quoteId && item.contactEmail && item.contactName) {
        const params = new URLSearchParams();
        params.append('id', item.quoteId);
        params.append('to', item.contactEmail);
        params.append('contactName', item.contactName);

        await this._quoteService.sendKit(params)
          .then(() => {
            this.showmsg({text: 'Um e-mail foi enviado contendo o Kit em anexo.', type: 'success'});
          })
          .catch((error) => {
            if(error && error.response && error.response.status === 400) {
              this.showmsg({text: error.response.data.message, type: 'error'})
            } else {
              this.showmsg({text: 'Ocorreu um erro ao tentar enviar o Kit.', type: 'error'});
            }
          })
          .finally(() => {
            this.setDialogLoading(false);
          });
      } else {
        this.setDialogLoading(false);
        this.showmsg({text: 'As informações necessárias para o envio do Kit não foram carregadas. (E-mail e nome do contato)', type: 'error'});
      }
    },
    async loadDataToRequestKit(quoteData, selectedJuridicalPerson) {
      const payload = this.createQuoteDTO(quoteData, selectedJuridicalPerson);
      
      await this._quoteService.requestKit(payload)
        .then((response) => {
          if(response && response.data && response.data.benefits && response.data.benefits.length) {
            this.saveSessionStorageData(response.data.benefits, payload.benefit, selectedJuridicalPerson);
          }
        })
        .catch((error) => {
          this.setDialogLoading(false);
          if(error && error.response && error.response.status === 400) {
            this.showmsg({text: error.response.data.message, type: 'error'})
          } else {
            this.showmsg({text: 'Ocorreu um erro ao tentar solicitar o Novo Kit.', type: 'error'})
          }
        });
    },
    createQuoteDTO(quoteData, selectedJuridicalPerson) {
      const type = selectedJuridicalPerson;

      let lead = null;
      if(quoteData && quoteData.juridicalPersonObj) {
        lead = {
          cnpj: quoteData.juridicalPersonObj.cnpj ? this.$util.removeMask(quoteData.juridicalPersonObj.cnpj) : null,
          commercialName: quoteData.juridicalPersonObj.legalName,
          city: {
            id: quoteData.juridicalPersonObj.city ? quoteData.juridicalPersonObj.city.id : null,
            name: quoteData.juridicalPersonObj.city ? quoteData.juridicalPersonObj.city.name : null,
            state: {
              id: quoteData.juridicalPersonObj.city && quoteData.juridicalPersonObj.city.state_id
                ? quoteData.juridicalPersonObj.city.state_id.id : null,
              name: quoteData.juridicalPersonObj.city && quoteData.juridicalPersonObj.city.state_id
                ? quoteData.juridicalPersonObj.city.state_id.name : null,
            }
          },
          contact: {
            name: quoteData.juridicalPersonObj.nameContact,
            mobilePhone: quoteData.juridicalPersonObj.phoneContact ? this.$util.removeMask(quoteData.juridicalPersonObj.phoneContact) : null,
            email: quoteData.juridicalPersonObj.emailContact,
            emailCC: quoteData.juridicalPersonObj.emailWithCopy,
          }
        }
      }

      let contractFeatures = null;

      if(quoteData && quoteData.planFiltersObj) {
        contractFeatures = {
          allEmployees: quoteData.planFiltersObj.allEmployees && quoteData.planFiltersObj.allEmployees.length
            ? quoteData.planFiltersObj.allEmployees[0] : null,
          withCopay: quoteData.planFiltersObj.allEmployees && quoteData.planFiltersObj.hasCopay.length
            ? quoteData.planFiltersObj.hasCopay[0] : null,
          classification: quoteData.planFiltersObj.planClassifications && quoteData.planFiltersObj.planClassifications.length
            ? quoteData.planFiltersObj.planClassifications.map(item => {
              return {
                id: parseInt(item),
                name: null
              }
            }) : null,
          accommodation: quoteData.planFiltersObj.geographicScopes && quoteData.planFiltersObj.accommodations.length
            ? quoteData.planFiltersObj.accommodations.map(item => {
              return {
                code: item,
                description: null,
              }
            }) : null,
          geographicScope: quoteData.planFiltersObj.geographicScopes && quoteData.planFiltersObj.geographicScopes.length
            ? quoteData.planFiltersObj.geographicScopes.map(item => {
              return {
                name: item
              }
            }) : null,
          hospitalProviders: quoteData.planFiltersObj.hospitalsObj && quoteData.planFiltersObj.hospitalsObj.length
            ? quoteData.planFiltersObj.hospitalsObj.map(item => {
              return {
                id: item,
                description: null
              }
            }) : null,
          laboratoryProviders: quoteData.planFiltersObj.hospitalsObj && quoteData.planFiltersObj.laboratoriesObj.length
            ? quoteData.planFiltersObj.laboratoriesObj.map(item => {
              return {
                id: item,
                description: null
              }
            }) : null,
        }
      }

      let ageRange = null;
      let benefit = [];
      if(selectedJuridicalPerson === 'PJ') {
        if(quoteData && quoteData.ageIntervalsObj.length) {
          ageRange = quoteData.ageIntervalsObj;
          ageRange.forEach((age, indexAge) => {
            if(indexAge < ageRange.length - 1) {
              age.beneficiariesFiftyNinePlus = null
            } else {
              age.beneficiariesFiftyNinePlus = quoteData.enumeratedAgesObj
            }
          })
        }

        if (quoteData && quoteData.benefitsObj) {
          benefit = this.filterBenefitCarrierByPlansSelecteds(quoteData.benefitsObj)
          benefit = benefit.map(benefitItem => {
            return {
              id: benefitItem.id,
              code: benefitItem.code,
              name: benefitItem.name,
              carriers: benefitItem.carriers.map(carrierItem => {
                let selectedPlans = [];
                if (carrierItem.planClassifications && carrierItem.planClassifications.length) {
                  carrierItem.planClassifications.forEach(planClassification => {
                    if (planClassification.plans && planClassification.plans.length) {
                      selectedPlans = selectedPlans.concat(planClassification.plans)
                    }
                  })
                }

                if (selectedPlans.length) {
                  selectedPlans = selectedPlans.map(plan => {
                    return {
                      id: plan.id,
                      description: plan.description,
                      name: plan.name
                    }
                  })
                }

                return {
                  id: carrierItem.id,
                  comercialName: carrierItem.comercialName,
                  name: carrierItem.name,
                  image: carrierItem.image,
                  isReference: carrierItem.isReference,
                  selectedPlans,
                  planClassifications: carrierItem.planClassifications
                }
              })
            }
          })
        }
      } else if(selectedJuridicalPerson === 'PJ_PLAN') {

        if(quoteData && quoteData.ageIntervalsObj.length) {
          ageRange = quoteData.ageIntervalsObj;
        }

        if (quoteData && quoteData.plansGroupByBenefitCarrierObj && quoteData.plansGroupByBenefitCarrierObj.length) {
          quoteData.plansGroupByBenefitCarrierObj.forEach(benefitCarrier => {
            const benefitFound = benefit.find(benefit => benefit.id === benefitCarrier.benefitId);

            if(benefitFound) {
              const indexOfBenefit = benefit.indexOf(benefitFound);

              if(indexOfBenefit >= 0) {
                const carrierFound = benefit[indexOfBenefit].carriers.find(carrier => carrier.id === benefitCarrier.carrierId);

                if(carrierFound) {
                  const indexOfCarrier = benefit[indexOfBenefit].carriers.indexOf(carrierFound);
                  if(indexOfCarrier >= 0) {
                    benefit[indexOfBenefit].carriers[indexOfCarrier].selectedPlans = benefitCarrier.plans.map(plan => {
                      const ageIntervals = plan.ageIntervals;

                      if(plan.enumeratedAges && plan.enumeratedAges.length) {
                        ageIntervals[ageIntervals.length - 1].beneficiariesFiftyNinePlus = plan.enumeratedAges;
                      }

                      return {
                        id: plan.id,
                        description: plan.description,
                        name: plan.name,
                        ageRange: ageIntervals
                      }
                    })
                  }

                } else {
                  let planClassifications = [];
                  const benefitFound = this.benefits.find(benefit => benefit.id === benefitCarrier.benefitId);
                  if(benefitFound) {
                    const indexOfBenefit = this.benefits.indexOf(benefitFound);
                    if(indexOfBenefit >= 0) {
                      const carrierFound = this.benefits[indexOfBenefit].carriers.find(carrier => carrier.id === benefitCarrier.carrierId);
                      if(carrierFound) {
                        planClassifications = carrierFound.planClassifications;
                      }
                    }
                  }

                  const carrier = {
                    id: benefitCarrier.carrierId,
                    comercialName: benefitCarrier.carrierComercialName,
                    name: benefitCarrier.carrierName,
                    directoryKit: benefitCarrier.carrierDirectoryKit,
                    image: benefitCarrier.carrierImage,
                    isReference: benefitCarrier.carrierIsReference,
                    planClassifications: planClassifications,
                    selectedPlans: benefitCarrier.plans.map(plan => {
                      const ageIntervals = plan.ageIntervals;

                      if(plan.enumeratedAges && plan.enumeratedAges.length) {
                        for(let i = 0; i <= 8; i++) {
                          ageIntervals[i].beneficiariesFiftyNinePlus = null;
                        }
                        ageIntervals[ageIntervals.length - 1].beneficiariesFiftyNinePlus = plan.enumeratedAges;
                      }

                      return {
                        id: plan.id,
                        description: plan.description,
                        name: plan.name,
                        ageRange: ageIntervals
                      }
                    })
                  }

                  benefit[indexOfBenefit].carriers.push(carrier);
                }
              }

            } else {
              let planClassifications = [];
              const benefitFound = benefit.find(benefit => benefit.id === benefitCarrier.benefitId);
              if(benefitFound) {
                const indexOfBenefit = benefit.indexOf(benefitFound);
                if(indexOfBenefit >= 0) {
                  const carrierFound = benefit[indexOfBenefit].carriers.find(carrier => carrier.id === benefitCarrier.carrierId);
                  if(carrierFound) {
                    planClassifications = carrierFound.planClassifications;
                  }
                }
              }

              const carrier = {
                id: benefitCarrier.carrierId,
                comercialName: benefitCarrier.carrierComercialName,
                name: benefitCarrier.carrierName,
                directoryKit: benefitCarrier.carrierDirectoryKit,
                image: benefitCarrier.carrierImage,
                isReference: benefitCarrier.carrierIsReference,
                planClassifications: planClassifications,
                selectedPlans: benefitCarrier.plans.map(plan => {
                  const ageIntervals = plan.ageIntervals;

                  if(plan.enumeratedAges && plan.enumeratedAges.length) {
                    for(let i = 0; i <= 8; i++) {
                      ageIntervals[i].beneficiariesFiftyNinePlus = null;
                    }
                    ageIntervals[ageIntervals.length - 1].beneficiariesFiftyNinePlus = plan.enumeratedAges;
                  }

                  return {
                    id: plan.id,
                    description: plan.description,
                    name: plan.name,
                    ageRange: ageIntervals
                  }
                })
              }

              benefit.push({
                id: benefitCarrier.benefitId,
                code: benefitCarrier.benefitCode,
                name: benefitCarrier.benefitName,
                carriers: [carrier]
              });
            }
          })
        }
      }

      let studyConfigurationId = null;
      if(quoteData && quoteData.projectObj ) {
        studyConfigurationId = quoteData.projectObj.id;
      }

      //send others benefits not selecteds to reload in edit option
      if (quoteData && quoteData.benefitsObj) {
        quoteData.benefitsObj.forEach(benefitItem => {
          benefitItem.carriers.forEach(carrierItem => {
            const benefitFound = benefit.find(item => item.id === benefitItem.id);
            if(benefitFound) {
              const indexOfBenefit = benefit.indexOf(benefitFound);
              if(indexOfBenefit >= 0){
                const carrierFound = benefit[indexOfBenefit].carriers.find(item => item.id === carrierItem.id);
                if(carrierFound) {
                  const indexOfCarrier = benefit[indexOfBenefit].carriers.indexOf(carrierFound);
                  benefit[indexOfBenefit].carriers[indexOfCarrier].planClassifications = carrierItem.planClassifications;
                } else {
                  benefit[indexOfBenefit].carriers.push(JSON.parse(JSON.stringify(carrierItem)));
                }
              }
            } else {
              benefit.push(JSON.parse(JSON.stringify(benefitItem)));
            }
          })
        })
      }
      //end

      const payload = {
        type,
        lead,
        contractFeatures,
        ageRange,
        benefit,
        studyConfigurationId
      }
      return payload;
    },
    filterBenefitCarrierByPlansSelecteds(benefits) {
      return benefits.map(benefit => {
        if(benefit) {
          const carriersFiltered = benefit.carriers.map(carrier => {
            const planClassificationsMaped = carrier.planClassifications.map(planClassification => {
              if(planClassification && planClassification.plans.some(plan => plan.selected)) {
                return {
                  ...planClassification,
                  plans: planClassification.plans.filter(plan => plan.selected)
                }
              } else {
                return null;
              }

            }).filter(planClassification => planClassification)

            if(carrier && planClassificationsMaped.length) {
              return {
                ...carrier,
                planClassifications: planClassificationsMaped,
              }
            } else {
              return null;
            }
          }).filter(carrier => carrier);

          if(carriersFiltered.filter(carrier => carrier).length) {
            return {
              ...benefit,
              carriers: carriersFiltered,
            }
          } else {
            return null;
          }
        }
        return null;

      }).filter(benefit => benefit);
    },
    saveSessionStorageData(calculatedBenefits, benefitsParam, selectedJuridicalPerson) {
      const plans = [];
      calculatedBenefits.forEach(benefit => {
        benefit.carriers.forEach(carrier => {
          carrier.selectedPlans.forEach(plan => {
            plans.push(plan);
          });
        });
      });

      const benefits = JSON.parse(JSON.stringify(benefitsParam));

      benefits.forEach(benefit => {
        benefit.carriers.forEach(carrier => {
          carrier.planClassifications.forEach(planClassification => {
            planClassification.plans.forEach(plan => {
              if(plan && plan.id) {
                const planFound = plans.find(planLoaded => parseInt(planLoaded.id) === parseInt(plan.id));
                if(planFound) {
                  plan.totalLives = planFound.totalLives;
                  plan.totalPrice = planFound.totalPrice;
                  plan.copay = planFound.copay;
                  plan.integrator = planFound.integrator;
                }
              }
            });
          });
        });
      });
      
      const quoteDataToUpdate = JSON.parse(atob(localStorage.getItem(this.localStorageKey)));
      quoteDataToUpdate.benefitsObj = JSON.parse(JSON.stringify(benefits));
      localStorage.setItem(this.sessionStorageKey, btoa(JSON.stringify(quoteDataToUpdate)));
      this.$router.push({name: 'calculate-quote', query: { type: selectedJuridicalPerson}});
    },
    async loadJWTToken() {
      if(this.$route.query && this.$route.query.token) {
        const sessionKey = "access_token";
        
        localStorage.setItem(sessionKey, this.$route.query.token);
        this.setDialogLoading(true);
        
        await this._xippAuthService.GetTokenFull()
          .then((response) => {
            if(response && response.data) {
              localStorage.setItem(sessionKey, response.data.token);
            }
          })
          .finally(() => {
            this.setDialogLoading(false);
          });
      }
    }
  },
  computed: {
    formatStartDate() {
      return this.quoteFilters.startDate
        ? moment(this.quoteFilters.startDate).format(this.dateFormatExp)
        : '';
    },
    formatEndDate() {
      return this.quoteFilters.endDate
        ? moment(this.quoteFilters.endDate).format(this.dateFormatExp)
        : '';
    },
  },
  beforeCreate() {
    this._quoteService = new QuoteService();
    this._xippAuthService = new XippAuthService();
  },
  async created() {
    if (this.$route.query.token) {
      await this.loadJWTToken();
    }
  },
};
</script>

<style scoped>

.component-col {
  height: 62px !important;
}

</style>
